export default __webpack_public_path__ + "static/greenwheat-bg-6eeae42b31e7a6d2d5c86d579c0ec994.jpg";